import React, { useState, useEffect } from "react";
import styles from "./PreviewInstruction.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";

const PreviewInstructions = (props) => {
  const [showIcon, setShowIcon] = useState(true);
  // console.log(showIcon);


  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {" "}
            {/* {props?.data?.required && <span style={{ color: "red" }}>*</span>} */}
            {props?.data?.value || props?.name}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {!showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>
        <div></div>
      </div>
      {!showIcon && (
        <div className={styles.subContent}>
          {props?.instruction && (
            <div className={styles.instructionText}>
              {props?.instruction}
            </div>
          )}

          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewInstructions;
